import { ITermCourse } from '../../../../interfaces/scheduler_interfaces';
import { TermScheduleFlags } from '../../../course_scheduler/services/term_schedule_flags';
import * as _4 from 'lodash4';
import { CourseDetailsFacade } from '../../../course_details/facades/course_details_facade';
import { ViewSectionsFacade } from '../../facades/view_sections_facade';

class CourseTileController {
  private course: ITermCourse;
  constructor(
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngCourseDetailsFacade: CourseDetailsFacade,
    private ngViewSectionsFacade: ViewSectionsFacade
  ) {}

  showSections() {
    return this.ngViewSectionsFacade.showSections(this.course);
  }

  isCoreqEnforcementEnabled() {
    return this.ngTermScheduleFlags.isCoreqEnforcementEnabled();
  }

  openCourseDetail() {
    this.ngCourseDetailsFacade.openCourseDetails(this.course.nk);
  }
}

class CourseTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      course: '<'
    };
    this.controller = CourseTileController;
    this.templateUrl = 'capability-ng-scheduler/src/views/term_courses/components/course_tile/course_tile.html';
  }
}
angular.module('capability-ng-scheduler').component('courseTile', new CourseTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/components/course_tile/course_tile.ts